import React, { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import api from "@/lib/api";

export default function EvidenceThumb({ file }) {
  const [url, setUrl] = useState(null);
  const [isImg, setIsImg] = useState(false);

  useEffect(() => {
    let created;
    if (!file.id) return;
    api.get(`/files/${file.id}`, { responseType: "blob" })
      .then((res) => {
        const b = res.data;
        setIsImg((b.type || "").startsWith("image/"));
        created = URL.createObjectURL(b);
        setUrl(created);
      })
      .catch(() => {});
    return () => { if (created) URL.revokeObjectURL(created); };
  }, [file.id]);

  if (!file.id) {
    return (
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-2 text-xs text-slate-600 flex items-center gap-2">
        <FileText className="h-4 w-4 text-slate-400" /> {file.name} <span className="text-slate-400">— {file.type}</span>
      </div>
    );
  }
  if (isImg && url) {
    return (
      <a href={url} target="_blank" rel="noreferrer" className="block" data-testid="evidence-thumb">
        <img src={url} alt={file.name} className="h-24 w-24 object-cover rounded-lg border border-slate-200" />
        <span className="text-[11px] text-slate-500 mt-1 block truncate w-24">{file.name}</span>
      </a>
    );
  }
  return (
    <a href={url || "#"} target="_blank" rel="noreferrer" download={file.name} data-testid="evidence-thumb"
      className="rounded-lg border border-slate-200 bg-white p-2 text-xs text-slate-700 flex items-center gap-2 hover:border-teal-brand/40">
      <Download className="h-4 w-4 text-teal" /> {file.name}
    </a>
  );
}
